import { Step, StepLabel, Stepper } from '@material-ui/core';
import React from 'react';
import currentActiveStep from '../../Profile/AccountSetup/utils/currentActiveStep';
import { Link } from 'react-router-dom';

let steps = [1, 2, 3];
export default function AccountStepper({
	title = 'ACCOUNT SETUP',
	error = '',
	exclaimation = false,
	loading = false,
	approved = false,
	redirectToKyc,
	otherProps,
	pending = false,
	hasWallet = false,
	submission_date = false
}) {
	const { active_step, message, link } = currentActiveStep(
		exclaimation,
		loading,
		hasWallet,
		submission_date,
		pending,
		approved
	);

	const isStepFailed = step => {
		return step === 1;
	};

	return (
		<>
			<h6 className="account_setup_title">{title}</h6>
			<Stepper
				activeStep={error ? 0 : active_step}
				className={`account_steps ${loading ? 'placeholder' : ''} `}
				{...otherProps}>
				{steps.map((label, index) =>
					exclaimation && isStepFailed(index) ? (
						<Step key={label} className={`${exclaimation ? 'skip_step' : ' '}`}>
							<StepLabel error={true}>{}</StepLabel>
						</Step>
					) : (
						<Step key={label}>
							<StepLabel>{}</StepLabel>
						</Step>
					)
				)}
			</Stepper>
			{/* {pending ? null : ( */}
			<Link
				href={'#kyc'}
				disabled={!!error}
				onClick={link !== 'KYC-SUBMIT' ? () => window.openScreen(link) : redirectToKyc}
				className="account_setup_steps">
				{error ? (
					<span style={{ color: 'red' }}>{error + ' unable to retreive data'}</span>
				) : (
					<span>{message} &gt;</span>
				)}
			</Link>
			{/* )} */}
		</>
	);
}
